import { render } from "./VpnDetails.vue?vue&type=template&id=35e09da6&scoped=true"
import script from "./VpnDetails.vue?vue&type=script&lang=js"
export * from "./VpnDetails.vue?vue&type=script&lang=js"

import "./VpnDetails.vue?vue&type=style&index=0&id=35e09da6&scoped=true&lang=scss"

import exportComponent from "/root/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35e09da6"]])

export default __exports__